const id = (value) => Number(value) || null;
const key = (line) => line?._clientKey || line?._destinationKey || line?.id || null;
const date = (value) => String(value || "").slice(0, 10);
const linePrice = (line, type) => Number(type === "requisition" ? line?.last_price_info?.last_price ?? line?.unit_price ?? 0 : line?.unit_price ?? 0);

export function purchasePriceSaveContext(form, line, type) {
  return {
    documentId: id(form?.id), lineKey: String(key(line)), itemId: id(line?.item_id),
    supplierId: id(type === "order" ? form?.supplier_id : line?.supplier_id), unitId: id(line?.unit_id),
    date: date(type === "order" ? form?.order_date : form?.request_date), currency: form?.currency || "EUR",
    price: linePrice(line, type), tenderId: id(line?.tender_id), priceSource: line?.price_source || null,
  };
}

// IDs/destinations can still be acknowledged after a newer price edit, but never on another line/document.
export function samePurchaseSaveLine(form, line, context) {
  return Boolean(line && context.documentId && id(form?.id) === context.documentId &&
    String(key(line)) === context.lineKey && id(line.item_id) === context.itemId);
}

export function canApplyPurchaseSavePrice(form, line, context, type, saved = {}) {
  if (!samePurchaseSaveLine(form, line, context)) return false;
  const current = purchasePriceSaveContext(form, line, type);
  if (!["supplierId", "unitId", "date", "currency", "price", "tenderId", "priceSource"].every((field) => current[field] === context[field])) return false;
  if (saved.supplier_id && id(saved.supplier_id) !== current.supplierId) return false;
  if (saved.unit_id && current.unitId && id(saved.unit_id) !== current.unitId) return false;
  if (saved.pricing_date && date(saved.pricing_date) !== current.date) return false;
  return true;
}
